import CustomizedTables from "components/ProgramsTable/programsTable";
import ProgramsEmptySchedule from "components/ProgramPage/ProgramsEmptySchedule";
import ProgramSectionHeader from "components/ProgramPage/ProgramSectionHeader";
import { fetchCat2Programs } from "helpers/jackrabbit/fetchCat2Programs";
import {
  filterAndSortClassRows,
  isClassScheduleFilterActive,
} from "helpers/jackrabbit/classScheduleFilter";
import { useCallback, useEffect, useMemo, useState } from "react";
import "./programDetailCard.css";

const ProgramDetailCard = ({
  count,
  sectionKey,
  jackrabbitSlug,
  jackrabbitCat2,
  cat2Description,
  categoryTitle,
  scheduleFilter,
  onFilterResults,
  hideSchedule,
}) => {
  const [categories, setCategories] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const fetchCategories = useCallback(async () => {
    setIsLoading(true);
    const response = await fetchCat2Programs({
      Cat1: jackrabbitSlug,
      Cat2: jackrabbitCat2,
    });
    setCategories(response || []);
    setIsLoading(false);
  }, [jackrabbitSlug, jackrabbitCat2]);

  useEffect(() => {
    fetchCategories();
  }, [fetchCategories]);

  const filteredResult = useMemo(
    () => filterAndSortClassRows(categories, scheduleFilter),
    [categories, scheduleFilter]
  );

  useEffect(() => {
    if (!onFilterResults || !sectionKey) return;

    if (isLoading) {
      onFilterResults(sectionKey, {
        matchCount: 0,
        sourceCount: 0,
        isLoading: true,
      });
      return;
    }

    onFilterResults(sectionKey, {
      matchCount: filteredResult.matchCount,
      sourceCount: categories.length,
      isLoading: false,
      rows: categories,
    });
  }, [
    filteredResult,
    isLoading,
    categories,
    onFilterResults,
    sectionKey,
  ]);

  const filterActive = isClassScheduleFilterActive(scheduleFilter);

  if (hideSchedule) {
    return null;
  }

  if (
    filterActive &&
    !isLoading &&
    categories.length > 0 &&
    filteredResult.rows.length === 0
  ) {
    return null;
  }

  const sectionClass =
    count % 2 === 0
      ? "programs-cat-section programs-cat-section--alt"
      : "programs-cat-section";

  return (
    <section className={sectionClass} aria-labelledby={`cat-${count}`}>
      <div className="programs-cat-section__inner">
        <header className="programs-cat-section__header">
          <ProgramSectionHeader
            id={`cat-${count}`}
            kicker="Class level"
            title={categoryTitle}
            size="compact"
          />
          {cat2Description && (
            <p className="programs-cat-section__desc">{cat2Description}</p>
          )}
        </header>
        <div className="programs-cat-section__table-wrap">
          {isLoading ? (
            <p className="programs-cat-section__status">Loading classes…</p>
          ) : categories.length > 0 ? (
            <CustomizedTables
              rows={filteredResult.rows}
              scheduleFilter={scheduleFilter}
            />
          ) : (
            <ProgramsEmptySchedule categoryTitle={categoryTitle} />
          )}
        </div>
      </div>
    </section>
  );
};

export default ProgramDetailCard;
